// extracted by mini-css-extract-plugin
export var banner = "_fe-0";
export var closeButton = "_fe-2";
export var greenCheckmark = "_fe-3";
export var hereLink = "_fe-4";
export var titleIcon = "_fe-1";